module.exports = __webpack_public_path__ + "static/media/page3_qyj2_bg_2.98033182.jpg";